<template>
  <div class="app-wrapper shareholder-wrap">
  <div class="outer-wrap" v-if="metaReady">
    <Logo></Logo>
    <h2 class="shareholder-hd" v-html="get(conferenceMeta, 'login_info.title', '')"></h2>
    <p class="shareholder-explain">입장을 위해 이메일 인증을 진행합니다.</p>
    <div class="input-wrap">
      <label>
        <select name="group-select" data-test="groupList" class="input-style01" v-model="selectedGroupCode">
          <option value="" selected disabled>그룹 선택</option>
          <template v-if="groupList.length > 0">
            <option v-for="({ groupcode, groupname }, groupIndex) in groupList" :key="groupcode + '_' + groupIndex" :value="groupcode">{{groupname}}</option>
          </template>
        </select>
      </label>
    </div>
    <div class="input-wrap">
      <label>
        <select name="subsidiary-select" data-test="subGroupList" class="input-style01" v-model="selectedMemberCode" @click="checkGroupCode">
          <option value="" selected disabled>회사 선택</option>
          <option v-for="({membercode, membername}, index) in memberList" :key="membercode + '_' + index" :value="membercode">{{membername}}</option>
        </select>
      </label>
    </div>
    <div class="input-wrap domain-input-wrap">
      <label>
        <input type="text" class="input-style01"
               v-model="emailPrefix"
               :disabled="selectedMemberCode === ''"
               @keydown="onKeyDownFromEmail">
      </label>
      <span class="domain-text">{{selectedDomain}}</span>
    </div>

    <div class="btn-verification-code-wrap">
      <button type="button" class="btn-verification-code" @click.prevent="sendAuthCode"> 인증번호 {{authCodeSendStatus ? '재전송' : '전송'}}</button>
    </div>

    <div class="input-wrap" :style="`visibility: ${authCodeSendStatus ? 'visible' : 'hidden'}`">
      <label>
        <input type="number"
               class="input-style01"
               placeholder="인증번호"
               v-model="userAuthCode"
               @keydown="onKeyDownFromSubmit"
        >
      </label>
    </div>
    <div class="button-wrap" :style="`visibility: ${authCodeSendStatus ? 'visible' : 'hidden'}`">
<!--      for develop-->
<!--      <input type="submit" @click.prevent="goLivePage()" value="확인(그냥 누르면 넘어감)">-->
      <button type="button" class="btn-confirm" @click.prevent="submitAuthCode">확인</button>
    </div>
    <div class="divide-line">
      <span>또는</span>
    </div>
    <div class="button-wrap">
      <button type="button" @click.prevent="goAuthFromCodePage" class="btn-certification-code">코드로 입장하기</button>
    </div>
    <p class="shareholder-notice">
      <span>이메일 인증이 어려운 외부인의 경우 코드 입력을 통해 입장해주세요.</span>
    </p>
  </div>
  </div>
</template>
<script>
import _ from 'lodash'
import Logo from '@/pages/conference/components/Logo'
import {
  getConferenceMetaInfo,
  getPartnersMailList,
  postAuthenticateCode,
  postRequestAuthMail
} from '@/common/utils/request.conference'
import {
  PATH_NAME_CONFERENCE_AUTH_FROM_CODE,
  PATH_NAME_CONFERENCE_LIVE_VIEW
} from '@/common/resources/conference.router.const'
import {
  AUTHENTICATE_LIFE_TIME_MILLISECONDS,
  setAuthCookieForConference,
  setCompanyName
} from '@/pages/conference/js/conference.utils'
const COMMON_DONT_SEND_AUTH_MAIL = '현재 인증 번호 발송이 불가능 합니다.'
export default {
  name: 'PartnersHome',
  components: {
    Logo
  },
  data () {
    return {
      groupList: [],
      selectedGroupCode: '',
      memberList: [],
      selectedMemberCode: '',
      selectedDomain: '',
      selectedMemberName: '',
      emailPrefix: '',
      authCodeSendStatus: false,
      // authCodeSendStatus: true,
      userAuthCode: '',
      metaReady: false,
      conferenceMeta: null
    }
  },
  methods: {
    get: _.get,
    goLivePage () {
      setAuthCookieForConference(AUTHENTICATE_LIFE_TIME_MILLISECONDS)
      this.$router.push({ name: PATH_NAME_CONFERENCE_LIVE_VIEW })
    },
    checkGroupCode () {
      if (this.selectedGroupCode === '') {
        alert('그룹을 선택해 주세요.')
      }
    },
    onKeyDownFromEmail (e) {
      if (e.key === 'Enter' || e.code === 'Enter') {
        e.preventDefault()
        this.sendAuthCode()
      }
    },
    onKeyDownFromSubmit (e) {
      if (e.key === 'Enter' || e.code === 'Enter') {
        e.preventDefault()
        this.submitAuthCode()
      }
    },
    setGroupData () {
      getPartnersMailList().then(({ data }) => {
          this.groupList = _.get(data, 'list', [])
      })
    },
    validateEmail () {
      if (this.selectedGroupCode === '') {
        alert('그룹을 선택해 주세요.')
        return false
      } else if (this.selectedMemberCode === '') {
        alert('회사를 선택해 주세요.')
        return false
      } else if (this.emailPrefix === '' || this.selectedDomain === '') {
        alert('이메일을 입력해 주세요.')
        return false
      }
      return true
    },
    validateAuthCode () {
      if (this.userAuthCode === '') {
        alert('인증번호를 입력해 주세요.')
        return false
      }
      return true
    },
    sendAuthCode () {
      if (this.validateEmail()) {
        const userEmail = this.emailPrefix + this.selectedDomain
        postRequestAuthMail({
          groupcode: this.selectedGroupCode,
          email: userEmail,
          membercode: this.selectedMemberCode
        }, () => {
          this.goLivePage()
        }).then(({ data }) => {
          // forTest only start--
          // const authCode = _.get(data, 'authCode', '')
          // if (authCode !== '') {
          //   this.userAuthCode = authCode
          // }
          // forTest only end
          const { resultcode, resultmessage = COMMON_DONT_SEND_AUTH_MAIL } = data
          if ((resultcode === '200' || resultcode === 200) && resultmessage === 'success') {
              alert(userEmail + '으로\n인증번호가 전송되었습니다.\n인증번호 전송까지 시간이 소요되거나 지연될 수 있습니다.\n\n' +
                '계속해서 인증번호가 수신되지 않을 경우 이메일 주소를 확인해 주시고 재전송하시거나, 스팸 메일로 분류 될 수 있으니 스팸 메일함을 확인해 주세요.')
              this.authCodeSendStatus = true
          } else if ((resultcode === '551' || resultcode === 551) && resultmessage === 'pass') {
            // for test only start
            // alert(`resultcode : "551" & resultmessage : "pass" 상황입니다.\n 박병주 책임에게 문의해주세요\n 테스트용메세지 이며 운영에 배포되지 않습니다.`)
            // for test only end
            this.goLivePage()
          } else {
            alert(resultmessage)
          }
        }).catch(() => {
          // for test only start
          alert(`resultcode : "551" & resultmessage : "pass" 상황입니다.\n 박병주 책임에게 문의해주세요\n 테스트용메세지 이며 운영에 배포되지 않습니다.`)
          // for test only end
          this.goLivePage()
        })
      }
    },
    submitAuthCode () {
      if (this.validateAuthCode()) {
        postAuthenticateCode({ email: this.emailPrefix + this.selectedDomain, authenticatecode: this.userAuthCode }).then(({ data }) => {
          console.log('auth result ::', data)
          const { resultcode, resultmessage } = data
          if ((resultcode === '200' || resultcode === 200) && resultmessage === 'success') {
            setCompanyName(this.selectedMemberName)
            this.goLivePage()
          } else if ((resultcode === '551' || resultcode === 551) && resultmessage === 'pass') {
            // for test only start
            // alert(`resultcode : "551" & resultmessage : "pass" 상황입니다.\n 박병주 책임에게 문의해주세요\n 테스트용메세지 이며 운영에 배포되지 않습니다.`)
            // for test only end
            this.goLivePage()
          } else {
            alert(resultmessage)
          }
        }).catch(() => {
          alert('인증에 실패 했습니다.')
        })
      }
    },
    setMemberList (groupCode) {
      const selectedGroup = this.groupList.filter((group) => {
        return groupCode === _.get(group, 'groupcode', '')
      })
      this.memberList = _.get(selectedGroup, '0.memberlist', [])
    },
    setMemberDomain (memberCode) {
      const selectedMember = this.memberList.filter((member) => {
        return memberCode === _.get(member, 'membercode', '')
      })
      this.selectedDomain = _.get(selectedMember, '0.memberemaildomain', '')
      this.selectedMemberName = _.get(selectedMember, '0.membername', '')
    },
    reset () {
      this.memberList = []
      this.selectedMemberCode = ''
      this.selectedDomain = ''
      this.emailPrefix = ''
    },
    goAuthFromCodePage () {
      this.$router.push({ name: PATH_NAME_CONFERENCE_AUTH_FROM_CODE })
    }
  },
  created () {
    this.setGroupData()
    getConferenceMetaInfo().then((response) => {
      this.conferenceMeta = response
      this.metaReady = true
    })
  },
  mounted () {
  },
  watch: {
    selectedGroupCode (newGroupCode, oldGroupCode) {
      if (newGroupCode !== oldGroupCode) {
        this.reset()
        this.setMemberList(newGroupCode)
      }
    },
    selectedMemberCode (newMemberCode, oldMemberCode) {
      if (newMemberCode !== oldMemberCode) {
        this.setMemberDomain(newMemberCode)
      }
    }
  }
}
</script>
